import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { noop } from "./armor-system-PLBUPNW2.js";
import { getWindow } from "./armor-system-4JVSZEDO.js";
import { durationNormal } from "./armor-system-XFLPR42X.js";

// src/hooks/useWindowSize.ts
import { useEffect, useState } from "react";
import { debounce } from "throttle-debounce";
var isClient = getWindow();
function getSize() {
  return {
    width: isClient ? window.innerWidth : void 0,
    height: isClient ? window.innerHeight : void 0
  };
}
function useWindowSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$debounceDuration = _ref.debounceDuration,
    debounceDuration = _ref$debounceDuration === void 0 ? durationNormal : _ref$debounceDuration;
  var _useState = useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    if (!isClient) {
      return noop;
    }
    function handleResize() {
      debounce(debounceDuration, setWindowSize)(getSize());
    }
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [debounceDuration]);
  return windowSize;
}
export { useWindowSize };